/**
 * Drafts are not invoiced: the API assigns the INV- number at completion and
 * stores an opaque `DRAFT-…` placeholder until then.
 */
export const DRAFT_BILL_PREFIX = 'DRAFT-';

export function isDraftBillNumber(billNumber: string | null | undefined): boolean {
  return typeof billNumber === 'string' && billNumber.startsWith(DRAFT_BILL_PREFIX);
}

/**
 * A PARKED bill keeps its `DRAFT-…` placeholder until completion, but staff
 * name it by its park reference ("Bill parked as #PKD-…"), so it reads
 * "Parked #PKD-…" (GP3-001).
 */
export function formatBillNumber(bill: {
  bill_number: string;
  status?: string;
  park_reference?: string | null;
}): string {
  if (bill.status === 'PARKED' && bill.park_reference) return `Parked #${bill.park_reference}`;
  return isDraftBillNumber(bill.bill_number) ? 'Draft (unnumbered)' : bill.bill_number;
}
